import {GraphData, GraphDataApi, GraphDataPeriod, GraphDataResolution} from "../../../../../../domain/Fund";
import {formatDateToText} from "../../../../../../common/util/Functions";

export const mapApiToData = (apiData: GraphDataApi): GraphData => ({
    series: apiData.map((serie) => ({
        points: serie.utviklingsverdier.map((point) => ({
            x: Date.parse(point.dato),
            y: Math.round(point.verdi),
        })),
    })),
});

export const yearParse = (milliseconds: string) => formatDateToText(new Date(+milliseconds), 'yyyy');
export const monthParse = (milliseconds: string) => formatDateToText(new Date(+milliseconds), 'MMm');
export const monthYearParse = (milliseconds: string) => formatDateToText(new Date(+milliseconds), 'MMm yyyy');
export const dayParse = (milliseconds: string) => formatDateToText(new Date(+milliseconds), 'dd MMm');
export const GraphDataPeriodMap: Record<
    GraphDataPeriod,
    {
        months: number;
        resolution: GraphDataResolution;
        fullLabel: string;
        shortLabel: string;
        dateParse: (milliseconds: string) => string;
    } | null
> = {
    [GraphDataPeriod.SINCE_START]: null,
    [GraphDataPeriod.THIS_YEAR]: null,
    [GraphDataPeriod.LAST_7_DAYS]: null,
    [GraphDataPeriod.LAST_30_DAYS]: {
        months: 1,
        resolution: GraphDataResolution.DAILY,
        fullLabel: 'Siste 30 dager',
        shortLabel: '30 dager',
        dateParse: dayParse,
    },
    [GraphDataPeriod.LAST_3_MONTHS]: {
        months: 3,
        resolution: GraphDataResolution.DAILY,
        fullLabel: 'Siste 3 mnd',
        shortLabel: '3 mnd',
        dateParse: monthParse,
    },
    [GraphDataPeriod.LAST_6_MONTHS]: {
        months: 6,
        resolution: GraphDataResolution.DAILY,
        fullLabel: 'Siste 6 mnd',
        shortLabel: '6 mnd',
        dateParse: monthYearParse,
    },
    [GraphDataPeriod.LAST_1_YEAR]: {
        months: 12,
        resolution: GraphDataResolution.MONTHLY,
        fullLabel: 'Siste 1 år',
        shortLabel: '1 år',
        dateParse: monthYearParse,
    },
    [GraphDataPeriod.LAST_3_YEARS]: {
        months: 36,
        resolution: GraphDataResolution.MONTHLY,
        fullLabel: 'Siste 3 år',
        shortLabel: '3 år',
        dateParse: yearParse,
    },
    [GraphDataPeriod.LAST_5_YEARS]: {
        months: 60,
        resolution: GraphDataResolution.MONTHLY,
        fullLabel: 'Siste 5 år',
        shortLabel: '5 år',
        dateParse: yearParse,
    },
};

export const getTickSize = (size: number) => {
    switch (true) {
        case size > 20_000:
            return 5_000;
        case size > 10_000:
            return 2_000;
        case size > 5_000:
            return 1_000;
        case size > 1_000:
            return 500;
        case size > 500:
        default:
            return 100;
    }
};

export const getTicks = (edgeValues?: { min: number; max: number }) => {
    if (!edgeValues) return undefined;
    const tickSize = getTickSize(edgeValues.max - edgeValues.min);

    edgeValues.min = Math.round(edgeValues.min / tickSize) * tickSize;
    edgeValues.max = Math.round(edgeValues.max / tickSize) * tickSize;

    const tickCount = (edgeValues.max - edgeValues.min) / tickSize;
    return Array.from({ length: tickCount + 1 }, (_, i) => edgeValues.min + i * tickSize);
};